import type { EmailAccountDtoStatusEnumKey } from 'korint-sdk';

export const EMAIL_ACCOUNT_STATUS_DOT: Record<EmailAccountDtoStatusEnumKey, string> = {
  connected: 'bg-green-500',
  connecting: 'bg-amber-500',
  disconnected: 'bg-amber-500',
  error: 'bg-red-500',
  paused: 'bg-gray-400',
};

export const emailAccountStatusTextClassName = (status: EmailAccountDtoStatusEnumKey) =>
  status === 'connected'
    ? 'text-muted-foreground'
    : status === 'error'
      ? 'text-destructive'
      : 'text-amber-600';
